/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback } from 'react';
import { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import { closeDialog } from '../../../app/dialog/dialog.actions';
import { SubmitButton } from '../../pages/common/forms/SubmitButton';
import { ConnectedDialog } from '../ConnectedDialog';
import { MeetingShortcutAddFileForm } from '../../pages/common/forms/MeetingShortcutAddFileForm';
import { IMeetingShortcutDialogProps } from './types';
import { useSelectWithParams } from '../../../utils/selector.utils';
import { dialogSelectors } from '../../../app/dialog/dialog.selectors';

export const MeetingShortcutDialog: FunctionComponent<IMeetingShortcutDialogProps> = () => {
  const dispatch = useDispatch();
  const props = useSelectWithParams(
    dialogSelectors.selectDialogProps,
    'meetingShortcutAddFileDialog',
  ) as IMeetingShortcutDialogProps;

  const shortcut = props ? props.shortcut : undefined;

  const onClose = useCallback(() => {
    dispatch(closeDialog('meetingShortcutAddFileDialog'));
  }, [dispatch]);

  return (
    <ConnectedDialog dialogKey="meetingShortcutAddFileDialog">
      <div className="popup new_trello_card_popup" style={{ display: 'block' }}>
        <div className="panel">
          <div className="panel-header small-header flex jcsb">
            <h3>{shortcut ? 'Edit' : 'Add'} a shortcut</h3>
            <span className="close-popup close" onClick={onClose}>
              <i className="icon-close" />
            </span>
          </div>
          <div className="panel-body">
            <MeetingShortcutAddFileForm shortcut={shortcut} />
          </div>
          <div className="panel-footer no-border flex jcr">
            <a className="link blueGray mr-2 close" onClick={onClose}>
              Close
            </a>
            <SubmitButton apiKey={'createTaskApi'} formName={'meeting-shortcuts-add-file-form'} text="Save" />
          </div>
        </div>
      </div>
    </ConnectedDialog>
  );
};
